<template lang="html">
  <div class="slide">
    <svg ref="scene" class="canvas" viewBox="0 0 4175 3006">
      <rect id="Frame" width="4175" height="3006" />
      <g transform="translate(300.51 163.64)">
        <ImageLazy ref="panel-1" width="1697" height="2651" :srcs="[
          `${publicPath}scenes/burro/Burro1-q80-w800.jpg`,
          `${publicPath}scenes/burro/Burro1.jpg`
        ]"/>
      </g>
      <g transform="translate(2202.19 165.66)">
        <ImageLazy ref="panel-2" width="1655" height="2646" :srcs="[
          `${publicPath}scenes/burro/Burro2-q80-w800.jpg`,
          `${publicPath}scenes/burro/Burro2.jpg`
        ]"/>
      </g>
    </svg>
    <SceneDialogue
      ref="dialogue-1"
      :width=".33"
      :tx=".02" :ty="0.82"
      :fontSize="20"
      :className="`minion`">
      Max spent the next five summers working full time on the expedition. He
      wrangled their burros because the scientists didn’t know how to.
    </SceneDialogue>
    <SceneDialogue
      ref="dialogue-2"
      :width=".33"
      :tx=".98" :ty=".82"
      :fontSize="20"
      :className="`minion`">
      Ansel Hall studied our lands and wanted to turn them into a National Park.
      It didn’t work out in Congress or the Navajo Tribal Council. Hall never
      came back.
    </SceneDialogue>
    <SceneAudio ref="scene-audio" :src="`${publicPath}scenes/burro/audio-charlie-navajo.mp3`" />
  </div>
</template>

<script>
import Template from "./Template.vue"
import SceneDialogue from "../SceneDialogue.vue"
import {TimelineLite, TweenLite} from "gsap"

export default {
  extends: Template,
  mounted() {
    const p1 = this.$refs["panel-1"].$el
    const p2 = this.$refs["panel-2"].$el
    const d1 = this.$refs["dialogue-1"].$el
    const d2 = this.$refs["dialogue-2"].$el
    TweenLite.set(p1, {opacity: 0, x: 20, transformOrigin: "center center"})
    TweenLite.set(p2, {opacity: 0, x: -20, transformOrigin: "center center"})
    TweenLite.set(d1, {opacity: 0})
    TweenLite.set(d2, {opacity: 0})

    // this.tl = new TimelineLite({paused: true})
    this.tl.add(TweenLite.to(p1, 1, {opacity: 1, x: 0}), 0.5)
    this.tl.add(TweenLite.to(p2, 1, {opacity: 1, x: 0}), 0.5)
    this.tl.add(TweenLite.to(d1, 1, {opacity: 1}), 1.5)
    this.tl.add(TweenLite.to(d2, 1, {opacity: 1}), 1.5)
  },
  methods: {
    enter() { this.tl.play() }
  },
  components: {
    SceneDialogue,
  }
}
</script>

<style lang="css" scoped>
.content { padding: 0.8em; }
</style>
